<div class="pop-inform-container" #popInform
     [ngClass]="type === 'loading' ? 'ani-duration' : 'ani-fade-in-out'">

    @if(type !== 'loading'){ 
        <img class="pop-icon" [src]="imageServe.getIcon('pop-'+ type +'.png')">
    } @else { 
        <span nz-icon class="pop-icon" nzType="loading" nzTheme="outline"></span> 
    }

    <p class="pop-con">
        <ng-content></ng-content>
    </p>
    
</div>